"use client";

import React from "react";
import aiChatBotServicesData from "../../data/ai-chat-bot";
import ServiceCard from "../../components/ServiceCard";
import styles from "./AiChatBotServicesCardSection.module.css";
import { useServiceData } from "../../hooks/useServiceData";

export default function AiChatBotServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;

  // Use backend data if available, otherwise fallback to static data
  const displayData = services?.items || aiChatBotServicesData;
  const sectionTitle = services?.title || "AI Chat Bot Services";
  const sectionSubtitle = services?.subtitle || "Build a smarter chatbot that converts and supports";

  return (
    <section className={styles.section}>
      <div className="container">
        <p className={styles.eyebrow} data-reveal>
          {sectionTitle}
        </p>
        <h2 className={styles.title} data-reveal>
          {sectionSubtitle}
        </h2>

        <div className={styles.grid}>
          {displayData.map((card, idx) => (
            <div key={idx} data-reveal>
              <ServiceCard
                title={card.title}
                description={card.description}
                bullets={card.bullets}
                tags={card.tags} // Backend uses 'tags'
                minHeight={card.minHeight || 400}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
